<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn btn-warning btn-icon mr-2" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
      <button class="btn btn-danger btn-icon" @click="initBusiness">
        <span class="ti-arrow-right"></span
        >{{ "school_control" | setText("Управлять школой") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "businesses",
    cardSetLink: "businesses",
    item: null,
    fields: [
      {
        key: "title",
        label: "Названи школы",
        isMultiLang: true,
        type: "field",
        textType: "text",
      },
      {
        key: "is_active",
        label: "is_active",
        type: "checkbox",
      },

      {
        col: "col-12",
        label: "Город / район",
        key: "cloud_location_id",
        type: "location",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
    initBusiness() {
      let business = this.item;

      if (business && business.id) {
        this.$loading(true);
        this.$http
          .get(`accounts/${business.id}`)
          .then((response) => {
            let data = response.data.data;
            localStorage.setItem("bid", data.id);
            this.$http.defaults.headers.common["bid"] = data.id;
            this.$store.dispatch("setRoot", false);
            this.$store.dispatch("setBusiness", data);
            this.$store.dispatch("setRoutes", data.routes);
            try {
              this.$router.push("/");
            } catch (error) {}
          })
          .catch((error) => {
            errorNotify(error, this.$notify);
          })
          .finally(() => {
            this.$loading(false);
          });
      }
    },
  },
};
</script>
<style>
</style>
